import { retrieveMiniCart } from './_retrieveMiniCart';

export const moveItemToWishList = (id, item, catEntry, orderId, attributes, spinSelector, quantity, price) => {
	var ajaxUrl = '/webapp/wcs/stores/servlet/InterestItemAdd?';

	ajaxUrl +=
		'orderItemId=' +
		item +
		'&orderId=' +
		orderId +
		'&updatePrices=1&storeId=301&catalogId=301&langId=-1&calculationUsageId=-1&productId=' +
		catEntry +
		'&field3=' +
		attributes +
		'&catEntryId=' +
		catEntry +
		'&errorViewName=3DInterestItemDisplay&wlFromAjaxBag=true';
	ajaxUrl += '&URL=InterestItemAdd%3fURL%3dInterestItemDisplay';
	ajaxUrl +=
		'&rURL=InterestItemAdd%3FwlFromAjaxBag%3Dtrue%26orderId%3d' +
		orderId +
		'%26field3%3d' +
		attributes +
		'%26orderItemId%3d' +
		item +
		'%26langId%3d-1%26storeId%3d301%26catalogId%3d301%26catEntryId%3d' +
		catEntry +
		'%26productId%3d' +
		catEntry +
		'%26URL%3dInterestItemDisplay';
	$.ajax({
		type: 'POST',
		url: ajaxUrl,
		success: function (data, textStatus) {
			if (data.indexOf('Verify Your Password') >= 0) {
				top.location = ajaxUrl;
			} else if (data.indexOf('You have reached the limit of items in your wishlist') >= 0) {
				var interestItemAddMessage =
					'<div id="addedToWishlist-error-alert" class="alert alert-danger alert-dismissible" role="alert"><button class="alert-dismiss" type="button" data-dismiss="alert" id="addedToWishlist-alert-close-btn"><i class="fa fa-times"></i></button>You have reached the limit of items in your wishlist.</div>';
				$(interestItemAddMessage).insertBefore($('#myDillardsDropdownDynamic'));
			} else {
				$('#' + id).remove();

				if ($('.shopping-bag-wrapper tbody').children().length <= 0)
					$('#myDillardsDropdownDynamic').html('<div class="emptyMessage">Your Shopping Bag is empty</div>');

				retrieveMiniCart('ShoppingBag');

				//remove item from shopping bag display
				if ($('.wishListPanel').hasClass('activePanel')) {
					$('#myDillardsRightFrameContent .ajaxBigLoader').stop().fadeIn(350);
					runAjax(1);
				}
			}

			return false;
		},
		error: function (jqXHR, textStatus, errorThrown) {
			var ajaxUrl2 = '/webapp/wcs/stores/servlet/InterestItemAdd?';

			ajaxUrl2 +=
				'orderItemId=' +
				item +
				'&orderId=' +
				orderId +
				'&updatePrices=1&storeId=301&catalogId=301&langId=-1&calculationUsageId=-1&productId=' +
				catEntry +
				'&field3=' +
				attributes +
				'&catEntryId=' +
				catEntry +
				'&errorViewName=3DInterestItemDisplay&wlFromAjaxBag=true';
			ajaxUrl2 += '&URL=InterestItemAdd%3fURL%3dInterestItemDisplay';
			ajaxUrl2 +=
				'&rURL=InterestItemAdd%3FwlFromAjaxBag%3Dtrue%26orderId%3d' +
				orderId +
				'%26field3%3d' +
				attributes +
				'%26orderItemId%3d' +
				item +
				'%26langId%3d-1%26storeId%3d301%26catalogId%3d301%26catEntryId%3d' +
				catEntry +
				'%26productId%3d' +
				catEntry +
				'%26URL%3dInterestItemDisplay';
			window.parent.location = ajaxUrl2;
			return false;
		},
	});
};
